import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { endOfDay, getUnixTime, startOfDay, subDays } from 'date-fns';

import { apiClient } from '@services/apiClient';

import { DEFAULT_TIMESTAMPS_PERIOD } from '../constants/defaultTimestampsPeriod';

interface IResponse {
  data: { [key: string]: { [key: string]: { id: number } } };
}

export const fftTimestampsKey = (pointId: number, axisId: number) => ['fftTimestamps', +pointId, axisId];

export const fftTimestampsFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/fft-timestamp`, {
    params: {
      installationPointId: queryKey[1],
      axisId: queryKey[2],
      from: getUnixTime(startOfDay(subDays(new Date(), DEFAULT_TIMESTAMPS_PERIOD))),
      to: getUnixTime(endOfDay(new Date())),
    },
  });

const fftTimestampsSelect = ({ data }: AxiosResponse<IResponse>) => data?.data;

export const useFftTimestampsQuery = ({
  enabled,
  pointId,
  axisId,
}: {
  enabled: boolean;
  pointId: number;
  axisId: number;
}) => {
  return useQuery({
    queryKey: fftTimestampsKey(pointId, axisId),
    queryFn: fftTimestampsFn,
    enabled,
    select: fftTimestampsSelect,
  });
};
